import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updatePassword } from "../API/axiosClient";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
// import JanhitChemist from "../image/Janhit Chemist.png";
import finallogo from "../image/finallogo.png";

import discount2 from "../image/discount2.png";

const ResetPasswordPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tokenValid, setTokenValid] = useState(true);

  // Extract token from the URL
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  // Check token validity
  useEffect(() => {
    if (!token) {
      setTokenValid(false);
      toast.error("Invalid or expired token!");
      navigate("/error");
    }
  }, [token, navigate]);

  // Formik setup
  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      new_password: Yup.string()
        .min(6, "Password must be at least 6 characters long")
        .required("New password is required"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("new_password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!token) return; // Avoid sending API request if token is invalid

      try {
        // Send API request to update the password
        const response = await updatePassword({
          new_password: values.new_password,
          confirm_password: values.confirm_password, // Include confirm_password
          token, // Include the token from URL in the API request
        });

        // Handle successful response
        toast.success("Password updated successfully!");
        navigate("/login");
      } catch (error) {
        // Handle error response
        toast.error(error.message || "Failed to update password!");
        console.error("Error during password update:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  // Return null if token is invalid
  if (!tokenValid) {
    return null;
  }

  return (
    <>
      <link rel="stylesheet" href="style.css" />
      <div className="brand-logo">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 col-xs-12">
              <div className="brand-logo-main text-center">
                <img src={finallogo} alt="Brand Logo" />
                {/* <img src={JanhitChemist} alt="Brand Logo" /> */}
              </div>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-7 col-12 col-xs-12 text-center weltezt">
              <img
                src={discount2}
                alt="Discount Banner"
                width="400"
                height="400"
              />
              <h5>Welcome to Janhit Chemist</h5>
              <p>
                Sign up with us and get exclusive discounts and saving on
                medicines. Get express delivery in 2 hours.
              </p>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5 col-12 col-xs-12">
              <div className="from-section">
                <h5>Change Password</h5>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="password"
                      className={`form-control ${
                        formik.touched.new_password &&
                        formik.errors.new_password
                          ? "is-invalid"
                          : ""
                      }`}
                      name="new_password"
                      placeholder="Enter New Password"
                      value={formik.values.new_password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.new_password &&
                    formik.errors.new_password ? (
                      <div className="invalid-feedback">
                        {formik.errors.new_password}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <input
                      type="password"
                      className={`form-control ${
                        formik.touched.confirm_password &&
                        formik.errors.confirm_password
                          ? "is-invalid"
                          : ""
                      }`}
                      name="confirm_password"
                      placeholder="Enter Confirm Password"
                      value={formik.values.confirm_password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.confirm_password &&
                    formik.errors.confirm_password ? (
                      <div className="invalid-feedback">
                        {formik.errors.confirm_password}
                      </div>
                    ) : null}
                  </div>
                  <div className="link-buttn">
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={formik.isSubmitting}
                    >
                      Submit
                    </button>
                  </div>
                </form>
                <p />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordPage;
